'use strict';

const isInViewport = require('./modules/helpers/isInViewport');
const isSmallView = require('./modules/helpers/isSmallView');
const damHelper = require('./dam/dam-helper');
const advent = require('./advent');

const $productExperinceBlock = $('.js-product-experience-block');
const $hotspot = $('.js-hotspot');
const $hotspotContainer = $('.js-hotspot-container');
const $videoHolder = $('.js-video-holder');
const $experienceBtn = $('.js-product-experience-button');
const $experienceBtnTrigger = $('.js-experience-btn-animation-trigger');
// const $experienceBtnTriggerMob = $('.js-experience-btn-animation-trigger-mobile');
const $closeButton = $('.js-close-video-overlay');

let ignoreInViewport = false;

damHelper.updateImages('.js-hidden-images-container');

function showExperienceButton() {
    if ($productExperinceBlock.hasClass('full-width') || ignoreInViewport) {
        return;
    }

    // let elementIsInView;
    // if (isSmallView()) {
    //     elementIsInView = isInViewport($experienceBtnTriggerMob);
    // } else {
    //     elementIsInView = isInViewport($experienceBtnTrigger);
    //}

    if (isInViewport($experienceBtnTrigger)) {
        $experienceBtn.addClass('fade-in');
    }
}

function addEvents() {
    $hotspot.on('click', onClickHotspot);
    $experienceBtn.on('click', onClickExperienceButton);
    $closeButton.on('click', onClickCloseButton);
    $(window).on('scroll', showExperienceButton);

    $('.js-product-details-button').on('click', function() {
        const $this = $(this);
        advent.pushAdventDataLayerDataForProductExperienceBlock($this.closest('.js-product-experience-block'),
            'product_details', $this.closest('.js-drag-list-item').index() + 1, 'product');
    });
}

// function resizeBrowserOnMobile() {
//     if (isSmallView()) {
//         const viewportHeight = $(window).innerHeight() * 0.01;
//         $('html').css('--vh', `${viewportHeight}px`);
//     }
// }

// function expandForMobile(parentContainer) {
//     const videoBlock = parentContainer.find('video');
//     const mediaBlock = parentContainer.find('.js-product-experience-media');
//     const width = videoBlock.width * (window.innerHeight / videoBlock.height);

//     parentContainer.find($videoHolder).css({
//         'width': width
//     });
//     mediaBlock.scrollLeft = (mediaBlock.scrollWidth / 2) - (window.innerWidth / 2);
// }

// function resetForMobileCollapse(parentContainer) {
//     const mediaContainer = parentContainer.find('.js-product-experience-media');

//     mediaContainer.animate({
//         scrollLeft: (mediaContainer.scrollWidth / 2) - (window.innerWidth / 2)
//     }, 300);
// }

function onClickCloseButton() {
    ignoreInViewport = false;
    const $this = $(this);
    const $parentExperienceBlock = $this.closest('.js-product-experience-block');

    // if (isSmallView()) {
    //     $parentExperienceBlock.find($('.js-product-experience-block video')).hide();
    //     resetForMobileCollapse($parentExperienceBlock);
    // }

    $parentExperienceBlock.find($hotspotContainer).removeClass('fade-in').addClass('hidden');
    $parentExperienceBlock.find($closeButton).removeClass('visible');

    setTimeout(function() {
        $parentExperienceBlock.removeClass('full-width');
        $parentExperienceBlock.find($experienceBtn).addClass('fade-in');
        $parentExperienceBlock.find($videoHolder).removeAttr('style');

        // if (isSmallView()) {
        //     $('body').removeClass('no-scroll');
        //     $parentExperienceBlock.removeClass('fixed');
        //     $('html, body').animate({
        //         scrollTop: $parentExperienceBlock.data('window-scroll-top')
        //     }, 500);

        //     setTimeout(function() {
        //         $('.js-product-experience-block video').show();
        //     }, 1000);
        // }
    }, isSmallView() ? 300 : 0);

    advent.pushAdventDataLayerDataForProductExperienceBlock($this.closest('.js-product-experience-block'), 'exit');
}

function onClickExperienceButton() {
    ignoreInViewport = true;
    const $this = $(this);
    const $parentExperienceBlock = $this.closest('.js-product-experience-block');

    // if (isSmallView()) {
    //     $parentExperienceBlock.find($('video')).hide();
    // }

    $parentExperienceBlock.addClass('full-width');

    $parentExperienceBlock.find($closeButton).addClass('visible');
    $parentExperienceBlock.find($experienceBtn).removeClass('fade-in');

    // if (isSmallView()) {
    //     $('html, body').animate({
    //         scrollTop: $parentExperienceBlock.offset().top
    //     }, 500);

    //     setTimeout(function() {
    //         $parentExperienceBlock.addClass('fixed');
    //         $('body').addClass('no-scroll');
    //     }, 500);

    //     expandForMobile($parentExperienceBlock);
    //     $parentExperienceBlock.data('window-scroll-top', $(window).scrollTop());
    //     $parentExperienceBlock.find($hotspotContainer).removeClass('hidden').addClass('fade-in');

    //     setTimeout(function() {
    //         $parentExperienceBlock.find($('video')).show();
    //     }, 1000);
    // } else {
        setTimeout(function() {
            $parentExperienceBlock.find($hotspotContainer).removeClass('hidden').addClass('fade-in');
        }, 1000);
   // }

    advent.pushAdventDataLayerDataForProductExperienceBlock($this.closest('.js-product-experience-block'), 'open');
}

function onClickHotspot(e) {
    const $target = $(e.currentTarget);
    const $this = $(this);
    const $parentExperienceBlock = $this.closest('.js-product-experience-block');
    const $closeButton = $parentExperienceBlock.find($('.js-close-video-overlay'));
    const $popup = $parentExperienceBlock.find($('.js-popup'));
    const $popupImage = $parentExperienceBlock.find($('.js-popup .js-popup-image'));
    const $popupBgImage = $parentExperienceBlock.find($('.js-popup .js-popup-bg-image'));
    const $popupSubtitle = $parentExperienceBlock.find($('.js-popup .js-popup-subtitle'));
    const $popupTitle = $parentExperienceBlock.find($('.js-popup .js-popup-title'));
    const $popupDescription = $parentExperienceBlock.find($('.js-popup .js-popup-description'));
    const $popupCloseBtn = $parentExperienceBlock.find($('.js-close-popup'));
    const $hotspotContainer = $parentExperienceBlock.find($('.js-hotspot-container'));
    const $hiddenImage = $parentExperienceBlock.find($('.js-hidden-images-container img'));

    const zoomVideoSrc = $target.attr('data-zoom-src');
    const reverseVideoSrc = $target.attr('data-reverse-src');
    const zoomPosterSrc = $target.attr('data-zoom-poster-src');
    const reversePosterSrc = $target.attr('data-reverse-poster-src');
    const popupSubtitle = $target.attr('data-popup-subtitle');
    const popupTitle = $target.attr('data-popup-title');
    const popupImageSrc = $target.attr('data-popup-image');
    const popupBgImageSrc = $target.attr('data-popup-bg-image');
    const popupDescription = $target.attr('data-popup-description');
    const popupPosition = $target.attr('data-popup-position');
    const bgImageIndex = $target.attr('data-image-id');
    const initialImageId = $parentExperienceBlock.find($('.js-hidden-images-container img:first-child')).attr('data-image-id');

    // append the correct content for the popup that's insinde the hotspot
    $popupSubtitle.append(popupSubtitle);
    $popupTitle.append(popupTitle);
    $popupDescription.append(popupDescription);
    $popupImage.attr('data-src', popupImageSrc);
    $popupBgImage.attr('data-src', popupBgImageSrc);
    $popup.addClass(popupPosition);

    damHelper.updateImages('.js-popup');

    $hotspotContainer.removeClass('fade-in');
    $closeButton.removeClass('visible');

    const $container = $('.js-experience-video-container', $parentExperienceBlock);

    // handle closing the popup
    $popupCloseBtn.on('click', function() {
        $popup.removeClass('open');
        $closeButton.addClass('visible');

        setTimeout(function() {
            $hotspotContainer.addClass('fade-in');
        }, 3000);

        setTimeout(function() {
            // remove the popup content
            $popupSubtitle.empty();
            $popupTitle.empty();
            $popupDescription.empty();
            $popupImage.attr({'src': '', 'data-src': ''});
            $popupBgImage.attr({'src': '', 'data-src': ''});
            $popup.removeClass(popupPosition);
        }, 1000);

        // show the correct hidden image before transition out video
        $hiddenImage.css('z-index', '0');
        $hiddenImage.each(function(index, child) {
            if (child.getAttribute('data-image-id') == bgImageIndex) {
                $(child).css('z-index', '10');
            }
        });

        // start the transition out video
        damHelper.updateVideo($container, {'asset': reverseVideoSrc, 'posterimage': reversePosterSrc, 'loop':'0'},
            function() {
            const $video = $parentExperienceBlock.find($('.s7videoplayer video'));

            $video.off('ended').on('ended', function() {
                // show the correct hidden image before transition out video
                $hiddenImage.css('z-index', '0');
                $hiddenImage.each(function(index, child) {
                    if (child.getAttribute('data-image-id') == initialImageId) {
                        $(child).css('z-index', '10');
                    }
                });

                // start the initial looping video after the transition out video is done
                damHelper.updateVideo($container, {'asset': $container.attr('data-initial-video'), 'posterimage': $container.attr('data-initial-poster')});

                $hotspotContainer.addClass('fade-in');
            });
        });
    });

    // show the correct hidden image before the transition in video
    $hiddenImage.css('z-index', '0');
    $hiddenImage.each(function(index, child) {
        if (child.getAttribute('data-image-id') == initialImageId) {
            $(child).css('z-index', '10');
        }
    });

    // start the transition in video
    damHelper.updateVideo($container, {'asset': zoomVideoSrc, 'posterimage': zoomPosterSrc, 'loop': '0'},
        function() {
        const $video = $parentExperienceBlock.find($('.s7videoplayer video'));

        setTimeout(function() {
            $popup.addClass('open');
        }, 3000);

        $video.off('ended').on('ended', function() {
            // remove the popup and its content after the transition in video is done
            $popup.removeClass('open');

            setTimeout(function() {
                // remove the popup content
                $popupSubtitle.empty();
                $popupTitle.empty();
                $popupDescription.empty();
                $popupImage.attr({'src': '', 'data-src': ''});
                $popupBgImage.attr({'src': '', 'data-src': ''});
                $popup.removeClass(popupPosition);
            }, 1000);

            if (!$closeButton.hasClass('visible')) {
                $closeButton.addClass('visible');
            }

            // show the correct hidden image before the transition out video
            $hiddenImage.css('z-index', '0');
            $hiddenImage.each(function(index, child) {
                if (child.getAttribute('data-image-id') == bgImageIndex) {
                    $(child).css('z-index', '10');
                }
            });

            // start the transition out video
            damHelper.updateVideo($container, {'asset': reverseVideoSrc, 'posterimage': reversePosterSrc, 'loop':'0'},
            function() {
                const $video = $parentExperienceBlock.find($('.s7videoplayer video'));

                $video.off('ended').on('ended', function() {
                    // show the correct hidden image
                    $hiddenImage.css('z-index', '0');
                    $hiddenImage.each(function(index, child) {
                        if (child.getAttribute('data-image-id') == initialImageId) {
                            $(child).css('z-index', '10');
                        }
                    });

                    // start the initial looping video after the transition out video is done
                    damHelper.updateVideo($container, {'asset': $container.attr('data-initial-video'), 'posterimage': $container.attr('data-initial-poster')});

                    $hotspotContainer.addClass('fade-in');
                });
            });
        });
    });

    advent.pushAdventDataLayerDataForProductExperienceBlock($this.closest('.js-product-experience-block'), 'view');
}

/**
 * Checks if the productExperience element exists on the page
 *
 * @returns {Boolean} result of test
 */
const shouldInit = () => {
    return $productExperinceBlock.length > 0;
};

const productExperience = {
    init: () => {
        if (shouldInit()) {
            addEvents();
            showExperienceButton();
            //resizeBrowserOnMobile();
        }
    }
};

module.exports = productExperience;
